import type { TextFieldHelpTextProps } from './textField.types'

import Box from '../box'
import { useStyleConfig, vui } from '../core'
import P from '../p'
import { cs, isJsx } from '../utils'
import { fieldColors } from './consts'
import { useTextFieldContext } from './context'

/** Displaying help text below the field. */
export const TextFieldHelpText = vui<'div', TextFieldHelpTextProps>((props, ref) => {
  const { className, children, isError, ...rest } = props
  const fieldProps = useTextFieldContext()
  const mergedProps = { ...fieldProps, ...props }
  const styles = useStyleConfig('Input', mergedProps)

  const color = isError ? fieldColors.error : fieldColors.helpText

  if (isJsx(children)) {
    return (
      <Box
        alignItems="flex-start"
        className={cs('vui-textFieldHelpText', className)}
        color={color}
        display="flex"
        ref={ref}
        {...styles.helpText}
        {...rest}
      >
        {children}
      </Box>
    )
  }
  // Fallback for string children
  return (
    <P
      alignItems="flex-start"
      className={cs('vui-textFieldHelpText', className)}
      color={color}
      display="flex"
      mb={0}
      ref={ref}
      size="sm"
      {...styles.helpText}
      {...rest}
    >
      {children}
    </P>
  )
})

TextFieldHelpText.displayName = 'TextFieldHelpText'
export default TextFieldHelpText
